import React, { PureComponent } from 'react';

import { translate } from '../utils';

class YAxis extends PureComponent {
  render() {
    const { margin, ticks, y, unit, drawTickLines } = this.props;
    return (
      <g className="chart__yaxis chart__axis" transform={translate(margin.left + 0.5, 0)}>
        {ticks.map(d => (
          <g className="tick" transform={translate(0, ~~y(d.value) + 0.5)} key={`yaxis__${d.value}`}>
            {drawTickLines && <line stroke="currentColor" x2="-6" />}
            <text fill="currentColor" x="-9" dy="0.32em">{d.label}{unit ? ` ${unit}`: ''}</text>
          </g>
        ))}
      </g>
    );
  }
}

export default YAxis;
